export enum UserType {
    PRIVATE = 1,
    COMPANY = 2,
    ENTREPRENEUR = 3,
}

export enum UserStatus {
    DELETED = 0,
    ACTIVE = 1,
    NEW = 2,
    BLOCKED = 5,
}

export enum ConfirmType {
    LINK = 1,
    CODE = 2,
}

export interface Profile {
    id: number;
    userId: number;
    type: UserType;
    name: string;
    restricted: boolean; // email not confirmed
    userStatus: UserStatus;
    deviceConfirmed: boolean;
    confirmType: ConfirmType;
    confirmDeviceResult: boolean; // TODO implement auth resource
    confirmDeviceMessage: string;
    nikname: string;
    phone: string;
    email: string;
    userRole: number;

    companyName: string;
    inn: string;
    kpp: string;
    ogrn: string;

    country: string;
    zipCode: string;
    city: string;
    address: string;
    superadmin?: boolean;
    superadminUser?: boolean;
    superadminPermission?: boolean;
    fromAdmin?: boolean;
}

export const initialProfile: Readonly<Profile> = {
    id: 0,
    userId: 0,
    type: UserType.PRIVATE,
    restricted: true,
    userRole: null,
    userStatus: null,
    deviceConfirmed: false,
    confirmType: ConfirmType.LINK,
    confirmDeviceResult: null,
    confirmDeviceMessage: null,
    name: '',
    nikname: '',
    phone: '',
    email: '',
    companyName: '',
    inn: '',
    kpp: '',
    ogrn: '',
    country: '',
    zipCode: '',
    city: '',
    address: '',
};
